import { useState } from 'react';

/**
 * hook to calculate ParentAlert children show/hide states
 * @returns {object} showParentChildren, setShowParentChildren
 */
const useGetParentChildrenStates = () => {
  const [showParentChildren, setShowParentChildren] = useState({});

  return {
    setShowParentChildren,
    showParentChildren,
  };
};

export default useGetParentChildrenStates;
